// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2FSa3","imageUploader":"EGiftCard_imageUploader__95HBf"};